import { render, staticRenderFns } from "./openAgain.vue?vue&type=template&id=604b7fb4&scoped=true"
import script from "./openAgain.vue?vue&type=script&lang=js"
export * from "./openAgain.vue?vue&type=script&lang=js"
import style0 from "./openAgain.vue?vue&type=style&index=0&id=604b7fb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b7fb4",
  null
  
)

export default component.exports